import "../../assets/scss/create-target.scss";

import { useAuth } from "../../hooks/useAuth";
import { useQuery } from "react-query";
import {
  customerFullName,
  employeeFullName,
  fetchActionsUtil,
  formatDateTime,
  paginationOptions,
} from "../../utils/helpers";

import currency from "currency.js";
import TableComponent from "../TableComponent";
import { Modal, ProgressBar } from "react-bootstrap";
import { useState } from "react";
import ReactPaginate from "react-paginate";

const SalesRepTargetViews = ({ show, setShow, title, id, type }) => {
  const { backendUrl } = useAuth();
  const [queryParams, setQueryParams] = useState({
    page: 1,
    limit: 10,
  });

  const { data } = useQuery(
    ["VIEW_TARGET_PERFORMANCE", id, queryParams],

    () =>
      fetchActionsUtil(
        `${backendUrl}/api/company/target-performance/${id}?page=${
          queryParams.page
        }&limit=${queryParams.limit}`,
      ),
    { onSuccess: (data) => {} },
    {
      enabled: true,
      keepPreviousData: true,
    },
  );

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th style={{ width: "100px" }}>Sales Rep</th>
          <th style={{ width: "100px" }}>Target Amount</th>
          <th style={{ width: "100px" }}>Amount Realized</th>
          <th style={{ width: "100px" }}>Success Rate</th>
        </tr>
      </thead>
    );
  };

  const tableData = (el, index) => {
    return (
      <>
        <td>{employeeFullName(el?.customers)}</td>

        <td>
          {currency(Number(el?.targetAmount)).format({
            symbol: "",
            separator: "",
          })}
        </td>
        <td>
          {currency(Number(el?.total)).format({
            symbol: "",
            separator: "",
          })}
        </td>
        <td>
          {" "}
          <ProgressBar
            now={Number(el?.progress)}
            label={`${Number(el?.progress)}%`}
          />
        </td>
      </>
    );
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      animation={false}
      enforceFocus={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h5>Sales Rep Target Performance</h5>
          <p className={"subtitle"}>View the performance of each sales rep </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"container"}>
          <div className="px-md-4">
            <TableComponent
              responsive
              borderless
              striped
              style={{ tableLayout: "fixed" }}
              tableHeadsFunction={tableHead}
              mainDataArray={data?.data?.eachSalesRepTarget || []}
              className="product-table  table-fixed"
              tableDataRowFunction={tableData}
              // tableRowClick={(e, el) => manageTransaction(e, el)}
            />
          </div>

          <div className="d-flex justify-content-between px-3 align-items-center pagination">
            {/*<p className="m-0">
                            Showing {data?.startIndex + 1} to{" "}
                            {data?.endIndex <= data?.count ? data?.endIndex : data?.count}{" "}
                            of {data.count} entries
                              </p> */}
            <div className="pagination_left">
              <p className="m-0 p-0">Show</p>
              <select
                value={queryParams.limit}
                name="limit"
                className="form-select "
                onChange={(e) => handleSearchQueryChange(e)}
              >
                <option value="10">10 rows</option>
                <option value="20">20 rows</option>
                <option value="30">30 rows</option>
                <option value="40">40 rows</option>
                <option value="50">50 rows</option>
                <option value="100">100 rows</option>{" "}
              </select>
            </div>

            <ReactPaginate
              {...paginationOptions}
              pageCount={Math.ceil(data?.data?.count / queryParams.limit)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={0}
              onPageChange={({ selected }) => {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                setQueryParams({
                  ...queryParams,
                  page: selected + 1,
                });
              }}
              forcePage={queryParams.page - 1}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SalesRepTargetViews;
